"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _getBackgroundColor = _interopRequireDefault(require("../utils/getBackgroundColor"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var getKnobTranslation = function getKnobTranslation(_ref) {
  var theme = _ref.theme,
    isChecked = _ref.isChecked,
    isIndeterminate = _ref.isIndeterminate;
  var knobMargin = theme.knobMargin,
    knobSize = theme.knobSize,
    width = theme.width;
  var isCheckedTranslation = "calc(".concat(width, " - ").concat(knobSize, " - 2 * ").concat(knobMargin, ")");
  var isIndeterminateTranslation = "calc(".concat(width, " / 2 - ").concat(knobSize, " / 2 - ").concat(knobMargin, ")");
  if (isChecked) {
    return "transform: translate(".concat(isCheckedTranslation, ")");
  }
  if (isIndeterminate) {
    return "transform: translate(".concat(isIndeterminateTranslation, ")");
  }
  return null;
};
var ToggleButtonIcon = _styledComponents["default"].span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  background: ", ";\n  outline: ", ";\n  outline-color: ", ";\n  outline-offset: 1px;\n  max-width: ", ";\n  min-width: ", ";\n  height: ", ";\n  border-radius: ", ";\n  align-items: center;\n  margin-right: ", ";\n  opacity: ", ";\n  &::after {\n    content: '';\n    width: ", ";\n    height: ", ";\n    background: ", ";\n    visibility: visible;\n    border-radius: 100%;\n    margin-left: ", ";\n    cursor: inherit;\n    transition: all 150ms ease;\n    ", "\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme,
    isChecked = _ref2.isChecked,
    isDisabled = _ref2.isDisabled,
    isIndeterminate = _ref2.isIndeterminate;
  return (0, _getBackgroundColor["default"])({
    theme: theme,
    isChecked: isChecked,
    isDisabled: isDisabled,
    isIndeterminate: isIndeterminate
  });
}, function (_ref3) {
  var isFocused = _ref3.isFocused;
  return isFocused && "2px solid";
}, function (_ref4) {
  var theme = _ref4.theme;
  return (
    // Fallback once `backgroundColorFocus` is deprecated
    theme.outlineColorFocus || theme.backgroundColorFocus
  );
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.width;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.width;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.height;
}, function (_ref8) {
  var theme = _ref8.theme;
  return "calc(".concat(theme.height, " / 2)");
}, function (_ref9) {
  var theme = _ref9.theme,
    hasLabel = _ref9.hasLabel;
  return hasLabel && theme.margin;
}, function (_ref10) {
  var isDisabled = _ref10.isDisabled,
    theme = _ref10.theme;
  return theme.iconSet !== 'novo' && isDisabled ? '0.5' : '1';
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.knobSize;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.knobSize;
}, function (_ref13) {
  var theme = _ref13.theme,
    isDisabled = _ref13.isDisabled;
  return isDisabled ? theme.knobColorDisabled : theme.knobColor;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.knobMargin;
}, function (_ref15) {
  var theme = _ref15.theme,
    isChecked = _ref15.isChecked,
    isIndeterminate = _ref15.isIndeterminate;
  return getKnobTranslation({
    theme: theme,
    isChecked: isChecked,
    isIndeterminate: isIndeterminate
  });
});
var _default = ToggleButtonIcon;
exports["default"] = _default;